import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsByKeywords",
    title: "Auto Tag Products By Keywords",
    description: "Automatically tag products by using a mapping table. Specify keywords and their corresponding tags.",
    example: "Mapping the keyword \"black\" to tag \"color_black\" will add the tag whenever the word black is found.",
    additional: [
        "Any number of keywords can be specified.",
        "You can select if the keywords should match a whole word.",
        "Keywords are case sensitive - input \"Sale\" and \"sale\" if you want to tag based on both versions of the word.",
        "Each mapping can override which fields are searched (Title, Description, or both) - by default the rule-level setting is used.",
    ],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsByKeywords",
                autoRemoveTags: true,
                mappings: [],
                fields: "OnlyTitle",
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.fields == null || rule.settings.fields === "") {
                        errors["fields"] = "fields is required";
                    }

                    if (rule.settings.autoRemoveTags == null) {
                        errors["autoRemoveTags"] = "autoRemoveTags is required";
                    }

                    var emptyMappings = false;

                    rule.settings.mappings.forEach(_ => {
                        emptyMappings = emptyMappings || (_.keyword == null || _.keyword === "");
                        emptyMappings = emptyMappings || (_.tag == null || _.tag === "");
                    });

                    if (emptyMappings) {
                        errors["mapping"] = "Blank keywords or tags are not allowed.";
                    }
                },
            ], null);
    }
};

export default ruleDefinition;